// extracted by mini-css-extract-plugin
module.exports = {"contactLinks":"socialLinks-module--contactLinks--rsI0o"};